import React, { useEffect } from "react";
import { Slider, SliderMark, SliderThumb, SliderTrack, Box, Button, Flex, Tooltip } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useUpsertDataMutation,useUpdateDecisionMutation } from "../app/api";
import { useSelector } from "react-redux";
import { path } from "ramda";

export const Scale = ({filtered, min = -1,data_input,done_item,next_done_item, max = 1,
  order_nr, decision_id, activity_id, participant_id,show_until,next_btn_visible,activity,all_done,next_to_show }) => {
  const [sliderValue, setSliderValue] = React.useState(0);
  const [changed, setChanged] = React.useState(false);
  const [moveForward] = useUpdateDecisionMutation();
  const [upsertData] = useUpsertDataMutation();
  const texts = useSelector(path(["ui","ui_texts"]));
  const {no,r_no,so_so,r_yes,yes,negative,r_negative,r_positive,positive} = useSelector(path(["ui","ui_texts"]));
  const keys = {
    main: [no,r_no,so_so,r_yes,yes],
    posNeg: [negative,r_negative,so_so,r_positive,positive],
  }[activity.scale || "main"];
  useEffect(() => {
    if (filtered.length) {setSliderValue(filtered[0].value_number);}
  }, [filtered]);

  const handleSubmit = (values) => {
    upsertData([{
      value_number: sliderValue,
      ...(filtered.length ? { id: filtered[0].id } : {}),
      ...(data_input ? {input_id:data_input} : {}),
      decision_id,
      participant_id,
      activity_id
    }]);
    setChanged(false);
  };

  const hide_next_btn = (done_item === null || data_input == null) ? (show_until > order_nr) : !next_btn_visible;

  return (
    <Box>
      <Formik
        enableReinitialize={true}
        initialValues={{ inputs: sliderValue }}
        onSubmit={handleSubmit}>
        {({ values }) => (
          <Form>
            <Slider
              value={sliderValue} min={min} max={max} mb={10} mt={5} step={0.5} colorScheme='teal'
              onChange={(v) => {setSliderValue(v);setChanged(true);}}>
              {keys.map((x, n) => (
                <SliderMark key={n} value={min + n*0.5} mt='1' fontSize='sm' maxWidth="80px" textAlign="center"
                  transform={`translateX(${(min + n*0.5) === max ? -70 : n === 0 ? -30 : -50}%)`}>{x}</SliderMark>
              ))}
              <SliderTrack/>
              <Tooltip hasArrow bg='teal.500' color='white' placement='top' label={sliderValue || "0"}>
                <SliderThumb />
              </Tooltip>
            </Slider>
            <Flex mt={2} gap={2}>
              <Button size="md" colorScheme="teal" type="submit" isDisabled={!changed}>
                {texts.save}
              </Button>
              {(hide_next_btn || !all_done) ? null : <Button size="md" colorScheme="blue" onClick={() => {
                moveForward({
                  id: decision_id,
                  done:order_nr,
                  done_item:next_done_item,
                  show_until:next_to_show
                })
              }}>
                {texts.next}
              </Button>}
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
